import {ACTIONS} from '@/common/auth/definitions/actions-methods';

export default class AllowedRequestsFilter {
    /**
     * Create a proxy handler for handling ACL.
     * @param {Auth} auth
     */
    constructor(auth) {
        this.auth = auth;
    }

    /**
     * Function call trap for the proxy handler.
     * @param {Function} operation
     * @param {{}} resource
     * @param {[]} args
     * @return {{fields: {}, items: Array}}
     */
    apply(operation, resource, args) {
        const acl = this.auth[resource.name];
        const isAllowed = (rules, ...methods) => methods.reduce(
            (result, method) => result && rules[method].isAllowed,
            true,
        );

        // Return empty response if user is not allowed to read resource and to run operation.
        if (acl && !isAllowed(acl, ACTIONS.all, ACTIONS.read, operation.name)) {
            return {
                items: [],
                fields: {},
            };
        }

        return Reflect.apply(operation, resource, args);
    }
}
